export default __webpack_public_path__ + "static/media/13.fc6bf5ed.png";